import React from 'react';
import { motion } from 'framer-motion';
import type { SolutionStoryLead as StoryLeadType } from '../../types/premium';
import ScrollReveal from './ScrollReveal';
import FloatingOrbs from './FloatingOrbs';
import './SolutionStoryLead.css';

interface SolutionStoryLeadProps {
  lead: StoryLeadType;
}

const SolutionStoryLead: React.FC<SolutionStoryLeadProps> = ({ lead }) => (
  <section className="solution-story-lead">
    <FloatingOrbs />
    <div className="container">
      <ScrollReveal className="solution-story-lead__inner">
        <span className="solution-story-lead__eyebrow">{lead.eyebrow}</span>
        <h2 className="solution-story-lead__title">{lead.title}</h2>
        <p className="solution-story-lead__subtitle">{lead.subtitle}</p>
        {lead.quote ? (
          <motion.blockquote
            className="solution-story-lead__quote"
            initial={{ opacity: 0, scale: 0.98 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            {lead.quote}
          </motion.blockquote>
        ) : null}
      </ScrollReveal>
    </div>
  </section>
);

export default SolutionStoryLead;
